import { Icon16ChainOutline, Icon20Chain, Icon20GlobeOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { type ReactElement, memo } from 'react';
import type { EViewMode } from 'reactApp/modules/settings/settings.types';
import { DataListControl } from 'reactApp/ui/DataListControl/DataListControl';
import type { PublishControlItemProps } from 'reactApp/ui/DataListItem/DataListItem.types';
import { Hint, HintPosition } from 'reactApp/ui/Hint/Hint';

import type { IconsSizeMap } from '../DataListItemCommonComponents.types';
import styles from './Publish.css';

interface PublishProps extends PublishControlItemProps {
    accent?: boolean;
    animate?: boolean;
    isShared?: boolean;
    viewType: EViewMode;
    className?: string;
    size?: number;
    itemId?: string;
}

const ICONS_SIZE_MAP: IconsSizeMap<{ chain: ReactElement; globe: ReactElement }> = {
    16: { chain: <Icon16ChainOutline />, globe: <Icon20GlobeOutline width={16} height={16} /> },
    20: { chain: <Icon20Chain />, globe: <Icon20GlobeOutline /> },
};

export const Publish = memo<PublishProps>(function Publish({
    accent = false,
    animate = false,
    isShared = false,
    isSeoEnabled = false,
    onClick,
    viewType,
    className,
    size = 20,
    itemId,
}) {
    const { chain, globe } = ICONS_SIZE_MAP[size];
    const icon = isSeoEnabled ? globe : chain;

    return (
        <Hint text={isShared ? 'Настроить доступ' : 'Поделиться ссылкой'} positionStrategy={HintPosition.relativeToCursor}>
            <DataListControl.New
                itemId={itemId}
                id="publish-icon"
                type={isSeoEnabled ? 'seo' : 'publish'}
                viewType={viewType}
                animate={animate}
                className={classNames(className, {
                    [styles.shared]: isShared,
                    [styles.accent]: accent || isSeoEnabled,
                })}
                onClick={onClick}
            >
                {icon}
            </DataListControl.New>
        </Hint>
    );
});
